import { useMutation, useQuery, useQueryClient } from "react-query";
import { enqueueSnackbar } from "notistack";
import { axiosInstance } from "../../axios/axiosInstance";

export interface UserProfile {
  displayName: string | null;
  // What other people see: the display name or a pseudonym such as "Użytkownik 4F2A".
  publicName: string;
  notifyNewMessages: boolean;
}

// Fetched once per session; the API also refreshes the stored e-mail used for notifications.
export function useUserProfile(enabled: boolean) {
  return useQuery("UserProfile", async () => (await axiosInstance.get("/api/UserProfile")).data as UserProfile, {
    enabled,
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: Infinity,
  });
}

export function useUpdateUserProfile() {
  const queryClient = useQueryClient();
  return useMutation(
    async (input: { displayName: string | null; notifyNewMessages: boolean }) =>
      (await axiosInstance.put("/api/UserProfile", input)).data as UserProfile,
    {
      onSuccess: (data) => {
        queryClient.setQueryData("UserProfile", data);
        queryClient.invalidateQueries("Conversations");
        enqueueSnackbar("Zapisano", { variant: "success" });
      },
      onError: (error: any) => {
        enqueueSnackbar(error?.response?.data?.message ?? "Nie udało się zapisać.", { variant: "error" });
      },
    }
  );
}
